import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Heading, TextButton } from 'wix-style-react';
import s from './ErrorBoundaries.scss';

export const MobileErrorBoundary: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Heading className={s.mobileHeading} appearance='H3'>
        {t('app.global_error.title')}
      </Heading>
      <div className={s.content}>
        <Text size='medium'>{t('app.global_error.content')}</Text>
        &nbsp;
        <TextButton
          as='a'
          onClick={() => {
            window.open(t('app.global_error.cta_link'));
          }}
          weight='normal'
        >
          {t('app.global_error.cta')}
        </TextButton>
      </div>
    </>
  );
};
